<h1 class="title">Maintenance Types</h1>
<h5>Manage Asset Maintenance Types</h5>
    <acabim-datatable
        #dataTable
        [dataSources]="dataSources"
        hasDetailView="true"
        [helpMessage]="helpMessage"
        [scrollable]="false"
        (showDetail)="toggleStatus(true)"></acabim-datatable>
    <div class="cas-action-buttons">
        <button class="cas-button-action" (click)="toggleStatus(true)">Add</button>
    </div>

<ng-template [ngIf]="showAddModal">
    <acabim-modal
        [display]="true"
        (status)="toggleStatus($event)"
        [title]="modalTitle"
        fixHeight="70vh"
        width="60vw">
        <acabim-admin-edit-type
            [typeDetails]="dataSources[0].detailData"
            (updateResult)="updateModalStatus($event)"></acabim-admin-edit-type>
    </acabim-modal>
</ng-template>
